import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-35755011"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "oxd-table-header-cell",
  role: "columnheader"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_card_th_sort = _resolveComponent("oxd-card-th-sort")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", {}, undefined, true),
    (_ctx.order !== undefined)
      ? (_openBlock(), _createBlock(_component_oxd_card_th_sort, {
          key: 0,
          order: _ctx.order,
          onOrder: _ctx.onOrder
        }, null, 8, ["order", "onOrder"]))
      : _createCommentVNode("", true)
  ]))
}